import {
 FETCH_SKILLS_REQUESTED,
 FETCH_SKILLS_SUCCEED,
 FETCH_SKILLS_FAIL,

} from './actionTypes';

export function fetchSkillsRequested(params) {
  return {
    type: FETCH_SKILLS_REQUESTED,
    payload: params,
  };
}

export function fetchSkillsSucceeded(params) {
  return {
    type: FETCH_SKILLS_SUCCEED,
    payload: params,
  };
}

export function fetchSkillsFailed(params) {
  return {
    type: FETCH_SKILLS_FAIL,
    payload: params,
  };
}



// WEBPACK FOOTER //
// ./src/store/skills/actions.js